import { ajaxService } from 'src/services/AjaxService';
import { IRequest, IResponse } from 'src/pods/system/interfaces';
import { IRefreshTokenDTO, ILogoutRequestDTO } from './RequestDtos';
import { IRefreshTokenResponseDTO } from './ResponseDtos';

export default class ApiCalls {
    public static refreshToken(request: IRequest<IRefreshTokenDTO>) {
        return ajaxService.post<IResponse<IRefreshTokenResponseDTO>>('/account/refresh-token', request.payload, {
            noAuthentication: true,
        });
    }

    public static logout(request: IRequest<ILogoutRequestDTO>) {
        return ajaxService.post<IResponse<any>>('/account/logout', request.payload);
    }
}
